import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AllServicesComponent } from '../all-services/all-services.component';

@Component({
  selector: 'app-edit-service',
  templateUrl: './edit-service.component.html',
  styleUrls: ['./edit-service.component.css']
})
export class EditServiceComponent implements OnInit {

  serviceName = ""
  serviceImage = ""
  serviceId = ''
  imageUplaoded = ''
  servicCost = ''
  constructor(public dialogRef: MatDialogRef<AllServicesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,){}

  ngOnInit(){
    console.log(this.data)
    this.serviceName = this.data.value.name
    this.serviceId = this.data.value.id
    this.serviceImage = this.data.value.image
    if(this.data.value.cost){
      this.servicCost = this.data.value.cost
    }
  }

  
  uploadServiceImage(e:any){
    console.log(e.target.value)
    this.imageUplaoded = e.target.files[0]
  }

  addService(){
    let data:any ;
    if(this.imageUplaoded != ''){
      data = {
        name : this.serviceName,
        image : this.imageUplaoded,
        service_id : this.serviceId
      }
    }else {
      data = {
        name : this.serviceName,
        service_id : this.serviceId
      }
    }

    if(this.data.value.cost != ''){
      data.cost = this.servicCost
    }
    
    console.log(data)
    this.dialogRef.close(data)
  }

  deletImage(){
    this.serviceImage = ''
  }

}
